/**
 * Shared notification state manager
 * Replaces global document/window properties to avoid global state pollution
 * This state is shared between NotificationDropdown and headerComponent
 */

interface NotificationState {
    closeClicked: boolean;
    flagTime: number;
    lastClickTarget: Element | null;
    justClosed: number | null;
    suppressToggle: boolean;
}

class NotificationStateManager {
    private state: NotificationState = {
        closeClicked: false,
        flagTime: 0,
        lastClickTarget: null,
        justClosed: null,
        suppressToggle: false
    };

    setCloseClicked(value: boolean, flagTime?: number): void {
        this.state.closeClicked = value;
        if (flagTime !== undefined) {
            this.state.flagTime = flagTime;
        }
    }

    getCloseClicked(): boolean {
        return this.state.closeClicked;
    }

    getFlagTime(): number {
        return this.state.flagTime;
    }

    setLastClickTarget(target: Element | null): void {
        this.state.lastClickTarget = target;
    }

    getLastClickTarget(): Element | null {
        return this.state.lastClickTarget;
    }

    setJustClosed(timestamp: number | null): void {
        this.state.justClosed = timestamp;
    }

    getJustClosed(): number | null {
        return this.state.justClosed;
    }

    setSuppressToggle(value: boolean): void {
        this.state.suppressToggle = value;
    }

    getSuppressToggle(): boolean {
        return this.state.suppressToggle;
    }

    reset(): void {
        this.state = {
            closeClicked: false,
            flagTime: 0,
            lastClickTarget: null,
            justClosed: null,
            suppressToggle: false
        };
    }

    // Clear flags that are older than specified age (in ms)
    clearStaleFlags(maxAge: number = 500): void {
        const now = Date.now();
        if (this.state.flagTime && (now - this.state.flagTime) > maxAge) {
            this.state.closeClicked = false;
            this.state.lastClickTarget = null;
        }
    }
}

// Export singleton instance
export const notificationState = new NotificationStateManager();
















